// src/langurage/en.js 

// 定义英文语言包对象
export default {
  button: {
    add: 'add',
    delete: 'delete',
    edit: 'edit',
    save: 'save',
    cancel: 'cancel',
    confirm: 'confirm',
    back: 'back',
    search: 'search',
    refresh: 'refresh',
    addor:'add',
    reset:'reset',
    MergeIssue:'MergeIssue',

    issue:'issue',
    signFor:'signFor',
    delete:'delete',
    details:'details',
    point:'pointGoods',
    photos:'photos'
  },
  radio:{
    shipment:'shipment',
    delivery:'delivery',
    total:'total'
  },
  
  form:{
    startTime:'startTime',
    endTime:'endTime',
    BusinessType:'BusinessType',
    DeliveryOrder:'DeliveryOrder',
    VehicleLicense:'VehicleLicense',
    DriverName:'DriverName'
  },
    navigateBar: {
      hotspot: 'Hotspot',
      experience: 'Experience',
      focus: 'Focus',
      recommend: 'Recommend'
    },
    tabs: {
      work: 'Work',
      private: 'Private',
      collect: 'Collect',
      like: 'Like'
    },
    taskDeliveryPlaceholder:{
      selectStartTime:'Select the start time',
      SelectEndtime:'Select the end time',
      deliveryOrder:'Please enter the delivery order number',
      licensePlate:'Please enter the license plate number',
      drivername:'Please enter the drivers name',
    },
    taskDeliverycolumns: {
      Serial:'Serial',
      DeliveryOrder:'DeliveryOrder',
      WaybillNumber:'WaybillNumber',
      LicensePlate:'LicensePlate',
      DriverName:'DriverName',
      Remarks:'Remarks',
      WarehouseOrder:'WarehouseOrder',
      CreationTime:'CreationTime',
      BusinessType:'BusinessType',
      Status:'Status',
      Operation:'Operation'
  
    },
  }